import { TFunction } from 'i18next';

import { ConversationReviewRating } from 'src/services/insights/types';

export interface RatingOption {
  emoji: string;
  label: string;
  value: ConversationReviewRating;
}

// Shared between VerdictCard (entry-point tiles + rated read-out) and
// FeedbackPanel (selectable tiles). Order matters: the negative option
// renders first so the layout matches the Figma.
export const getRatingOptions = (
  t: TFunction<'intent-conversation-analytics'>,
): RatingOption[] => [
  {
    emoji: '👎',
    label: t('conversationReview.missedTheMark'),
    value: 'missed_the_mark',
  },
  {
    emoji: '👍',
    label: t('conversationReview.goodEnough'),
    value: 'good_enough',
  },
];

// Comment-length bounds mirrored on the backend. Min length only applies on
// explicit submit (auto-saves accept any length up to the max so the user
// can iterate). Max is enforced on the input directly so the user can't
// type past it.
export const COMMENT_MAX_LENGTH = 2000;
export const COMMENT_MIN_LENGTH = 10;
